import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import _, { isEqual } from 'lodash';
import { selectStyles } from '../handbook/SelectStopList';

export const CHECKED = 1;
export const UNCHECKED = 2;
export const INDETERMINATE = -1;

const styles = {
  cursor: "pointer",
  display: "flex"
};

const IndeterminateCheckbox = (props) => {
  const { value, ...otherProps } = props;
  const checkRef = useRef();

  useEffect(() => {
    checkRef.current.checked = value === CHECKED;
    checkRef.current.indeterminate = value === INDETERMINATE;
  }, [value]);

  return (
    <input
      type="checkbox"
      ref={checkRef}
      {...otherProps}
      onChange={props.onChange}
      style={{ cursor: "pointer" }}
    />
  );
};

const Option = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.selectOption(props.data, "set-value");
  };
  return (
    <div
      style={{ display: "flex", ...props.getStyles("option", props) }}
      onClick={onClick}
    >
      <IndeterminateCheckbox
        value={props.isSelected ? CHECKED : UNCHECKED}
        key={props.isSelected}
      />
       {props.label}
    </div>
  );
};

const Group = (props) => {
  const { data, options, selectProps } = props;

  const selected = options.reduce(
    (prev, curr) => (prev += curr.isSelected ? 1 : 0),
    0
  );
  const value =
    selected === options.length
      ? CHECKED
      : selected === 0
      ? UNCHECKED
      : INDETERMINATE;

  const onChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const mapped = options.map(({ data }) => data);
    
    if (value === CHECKED || value === INDETERMINATE) {
      const newVal = selectProps.value.filter(item => {
        if(_.some(mapped, item)) {
          return false
        }
        return true
      })

      selectProps.onChange([...newVal], {action: "set-value"});
    }

    if (value === UNCHECKED) {
      if(selectProps.value === null || selectProps.value === undefined) {
        selectProps.onChange([...mapped], {action: "set-value"});
      } else {
        selectProps.onChange([...selectProps.value, ...mapped], {action: "set-value"});
      }
    }

  };

  return (
    <div onClick={onChange}>
      <div style={styles}>
        <IndeterminateCheckbox value={value} key={value} />
        {data.label}
      </div>
      <div style={{ marginLeft: "15px" }}>{props.children}</div>
    </div>
  );
};

const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
      order: 99
    };
  
    const title = items.join(", ");
    const length = items.length;
    const label = `${length} ${length === 1 ? "опция" : length < 5 ? "опции" : "опций"}`;
  
    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };
  
  const MultiValue = ({ index, getValue }) => {
    const overflow = getValue()
        .slice(0)
        .map((x) => x.label);
  
    return index === 0 ? (
        <MoreSelectedBadge items={overflow} />
    ) : null;
  };

export default function MultiSelect({ width=200, placeholder, loading, values = [], data=[], setData, disabled = false, notAll, blur }) {
    const [ selected, setSelected ] = useState([]);

    useEffect(() => {
        if (values) setSelected(values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const handleChange = () => (e) => {
        setSelected(e);
        if (!blur) setData(e);
    };

    const onBlur = () => {
        if (blur && !isEqual(values, selected)) setData(selected);
      }

    if (loading) return (
        <div style={{ width }}>
            <Select
                isLoading={true}
                placeholder={placeholder ? placeholder : 'Филиалы'}
            />
        </div>
    );

    return(
        <div style={{ width }}>
            <Select
                isDisabled={disabled || !data || data.length === 0}
                isMulti
                isSearchable
                menuPortalTarget={document.body}
                placeholder={placeholder ? placeholder : 'Select'}
                closeMenuOnSelect={false}
                options={notAll ? data : [{label: 'Выбрать все', options: data }]}
                noOptionsMessage={() => 'Нет данных'}
                value={selected}
                hideSelectedOptions={false}
                onChange={(e) => handleChange()(e)}
                onBlur={onBlur}
                components={{ 
                    Option, 
                    Group, 
                    MultiValue
                }}
                styles={{ ...selectStyles }}
            />
        </div>
    )
}